__turbopack_context__.v({
  "blink": "super-module-scss-module__16M0Kq__blink",
  "super": "super-module-scss-module__16M0Kq__super",
  "superContent": "super-module-scss-module__16M0Kq__superContent",
  "superImage": "super-module-scss-module__16M0Kq__superImage",
});
